import axios from 'axios'
import {authUrl, apiUrl} from '../../../config/env.js'
axios.defaults.withCredentials = true

export const checkAccessToken = (shainNo, token) => {
  return axios.post(authUrl + '/api/accessToken/check', {
    shain_no: shainNo,
    token: token
  })
}

export const checkRefreshToken = (shainNo, token) => {
  return axios.post(authUrl + '/api/refreshToken/check', {
    shain_no: shainNo,
    token: token
  })
}

export const getTokens = (shainNo, tokenId) => {
  return axios.get(authUrl + '/api/tokens/' + shainNo + '/' + tokenId)
}

export const deleteToken = (shainNo, refreshToken) => {
  return axios.post(authUrl + '/api/token/delete', {
    shain_no: shainNo,
    token: refreshToken + ''
  })
}

export const deleteTokens = (shainNo) => {
  return axios.get(authUrl + '/api/tokens/delete/' + shainNo)
}

export const popAuthList = (shainNo) => {
  return axios.get(apiUrl + '/auth/get/' + shainNo)
}

export const getLoginRights = (shainNo) => {
  return axios.get(authUrl + '/api/login/rights/' + shainNo)
}

export const getOwnerdLoginRights = (loginRights) => {
  return axios.post(authUrl + '/api/login/rights/all', {
    is_delete: loginRights
  })
}

export const SelectConcurrentDepartment = (ShainNo) => {
  return axios.get(apiUrl + '/auth/get/concurrentDepartment/' + ShainNo)
}

export const SelectAuthInfo = (ShainNoDigest) => {
  return axios.get(apiUrl + '/auth/get/info/' + ShainNoDigest)
}

export const SelectAuthCopyInfo = (ShainNo, TargetShainNo) => {
  return axios.post(apiUrl + '/auth/get/copyInfo', {
    'shain_no': ShainNo,
    'target_shain_no': TargetShainNo
  })
}

export const EditAuth = (
  LoginUser,
  ShainNo,
  ConcurrentDepartmentId,
  AuthTypeId,
  Auth,
  AuthCopy) => {
  return axios.put(apiUrl + '/auth/edit', {
    login_user: LoginUser,
    shain_no: ShainNo,
    concurrent_department_id: ConcurrentDepartmentId,
    auth_type_id: AuthTypeId,
    auth: Auth,
    auth_copy: AuthCopy
  })
}

/* export const EditAuth = (LoginUser,
  ShainNo,
  ConcurrentDepartmentId,
  InterviewList,
  SearchPerson,
  PlanList,
  Positioning,
  WorkersTransitive,
  InterviewRegister,
  PlanRegister,
  User,
  Office,
  Division,
  Post,
  AreaGroup,
  JobCategory,
  JobOffer,
  WorkerDetailItem) => {
  return axios.put(apiUrl + '/auth/edit', {
    login_user: LoginUser,
    shain_no: ShainNo,
    concurrent_department_id: ConcurrentDepartmentId,
    auth_type_id: AuthTypeId,
    auth: Auth
  })
} */

export const getEditHistory = (ShainNo) => {
  return axios.get(apiUrl + '/auth/edit/history/' + ShainNo)
}

export const ProhibitedLogin = (ShainNo, IsDelete) => {
  return axios.post(authUrl + '/api/login/prohibit', {
    shain_no: ShainNo,
    is_delete: IsDelete
  })
}

export const CreateEditHistory = (ShainNo,
  FunctionNo,
  ChangeItemName,
  BeforeChange,
  AfterChange,
  UpdatedShain) => {
  return axios.post(apiUrl + '/auth/editHistory/create', {
    shain_no: ShainNo,
    function_no: FunctionNo,
    change_item_name: ChangeItemName,
    before_change: BeforeChange,
    after_change: AfterChange,
    updated_shain: UpdatedShain
  })
}

export const GetAuthTypeAll = () => {
  return axios.get(apiUrl + '/authType')
}

export const GetAuthType = (Hash) => {
  return axios.get(apiUrl + '/authType/' + Hash)
}

export const CreateAuthType = (AuthType, AuthData) => {
  return axios.post(apiUrl + '/authType', {
    auth_type: AuthType,
    auth_data: AuthData
  })
}

export const EditAuthType = (AuthType, AuthData) => {
  return axios.put(apiUrl + '/authType', {
    auth_type: AuthType,
    auth_data: AuthData
  })
}

export const AuthTypeModal = (authData, useHidden) => {
  return axios.post(apiUrl + '/authType/modal', {
    auth_data: authData,
    use_hidden: useHidden
  })
}

export const CreateAuthAllocation = (deptId, postId, authTypeId) => {
  return axios.post(apiUrl + '/authAllocation', {
    dept_id: deptId,
    post_id: postId,
    auth_type_id: authTypeId
  })
}

export const GetAuthAllocationAll = () => {
  return axios.get(apiUrl + '/authAllocation')
}

export const GetAuthAllocaion = (hash) => {
  return axios.get(apiUrl + '/authAllocation/' + hash)
}

export const EditAuthAllocation = (id, deptId, postId, authTypeId) => {
  return axios.put(apiUrl + '/authAllocation', {
    auth_allocation_id: id,
    dept_id: deptId,
    post_id: postId,
    auth_type_id: authTypeId
  })
}

export const CreateFrontAuth = (funcId, funcName) => {
  return axios.post(apiUrl + '/frontAuth', {
    func_id: funcId,
    func_name: funcName
  })
}

export const CreateApiAuth = (funcId, apiId, apiName) => {
  return axios.post(apiUrl + '/apiAuth', {
    func_id: funcId,
    api_id: apiId,
    api_name: apiName
  })
}

export const FrontAuthModal = (authData) => {
  return axios.post(apiUrl + '/frontAuth/modal', authData)
}

export const AuthAllocaionShowCreate = () => {
  return axios.get(apiUrl + '/authAllocation/create')
}

export const AuthShowCreate = () => {
  return axios.get(apiUrl + '/auth/create')
}

export const AuthTypeShowCreate = () => {
  return axios.get(apiUrl + '/authType/create')
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js